import type { Components, Theme } from "@mui/material";

export const dialogTitleTheme: Components<Theme>["MuiDialogTitle"] = {
  defaultProps: {
    variant: "h1" as const,
  },
  styleOverrides: {
    root: ({ theme }) => ({
      margin: 0,
      padding: theme.spacing(4, 9, 3, 4),
    }),
  },
};
